<template>
    <div>
        <table-tool-bar>
            <template slot="left">
                <table-searcher
                    v-model="filter.keyword"
                    placeholder="请输入店面名称"
                    style="margin-left: 10px"
                    @search="search">
                </table-searcher>
            </template>
            <Button
                v-if="$can('add')"
                :class="preCls + 'button-margin'"
                :disabled="loading"
                type="primary"
                @click="onClickAdd">
                新增
            </Button>
        </table-tool-bar>
        <Table
            ref="mt"
            :columns="columns"
            :data="page.list"
            :loading="loading"
            :height="mtHeight">
            <!-- 操作列 -->
            <template v-slot:action="{ row }">
                <Button 
                    v-if="$can('view')"
                    type="default"
                    size="small"
                    style="margin-right: 5px"
                    @click="rowClickView(row)">
                    详情
                </Button>
                <Button
                    v-if="$can('update')"
                    type="default"
                    size="small"
                    style="margin-right: 5px"
                    @click="rowClickUpdate(row)">
                    修改
                </Button>
                <PoptipButton
                    v-if="$can('delete')"
                    text="删除"
                    transfer
                    placement="top-end"
                    type="default"
                    title="您确定删除这条记录吗？"
                    :ok="() => rowClickDelete(row)"/>
            </template>
        </Table>
        <!-- 底部分页 -->
        <table-pager
            :total.sync="page.total"
            :pageSize.sync="filter.pageSize"
            :pageNo.sync="filter.pageNo"
            @change="fetch">
        </table-pager>
        <!-- 弹出层 -->
        <smart-modal
            v-model="modal.showInfoForm"
            :title="actionTitle + '店面'"
            :width="800"
            :height="500"
            :maskClosable="false"
            @close-by-confirm="fetch">
            <m-shop-form
                v-if="modal.showInfoForm"
                :id="curId"
                :actionType="actionType"/>
        </smart-modal>
    </div>
</template>

<script>
import { mapCache } from '@/plugins/vux-data-cache'

import { shopInfoList, shopInfoDelete } from '@/api/shop'
import { ymdL } from '@/utils/helper'

import MShopForm from './m-shop-form'

export default {
    data() {
        return {
            mtHeight: 360,
            loading: false,
            curId: '',
            actionType: '', // 1 新增; 2 查看; 3 修改;
            page: {
                total: 0,
                list: [],
            },
            modal: {
                showInfoForm: false,
            },
            dict: {
                actionType: this.$dict.NULL,
            },
        }
    },

    components: { MShopForm },

    computed: {
        ...mapCache({
            filter: 'shopInfo',
        }),
        actionTitle() {
            if (this.dict.actionType) {
                return this.dict.actionType.val(this.actionType)
            }
            return ''
        },
        columns() {
            return [
                {
                    type: 'index',
                    title: '序号',
                    align: 'center',
                    width: 80,
                },
                {
                    key: 'shopName',
                    title: '店面名称',
                    align: 'left',
                    minWidth: 150,
                    tooltip: true,
                },
                {
                    key: 'tel',
                    title: '店面电话',
                    align: 'center',
                    minWidth: 120,
                },
                {
                    key: 'addr',
                    title: '店面地址',
                    align: 'left',
                    minWidth: 200,
                    tooltip: true,
                },
                {
                    key: 'remark',
                    title: '备注',
                    align: 'left',
                    minWidth: 150,
                    tooltip: true,
                },
                {
                    key: 'createTime',
                    title: '创建时间',
                    align: 'center',
                    minWidth: 150,
                },
                {
                    title: '操作',
                    align: 'center',
                    width: 180,
                    slot: 'action',
                    fixed: 'right',
                },
            ]
        },
    },

    created() {
        this.fetch()
    },

    mounted() {
        this.afterContainerResize((el, detector) => {
            this.mtHeight =
                detector.windowHeight -
                this.$refs.mt.$el.getBoundingClientRect().top -
                80
        })
    },

    methods: {
        fetch() {
            this.loading = true
            Promise.all([
                shopInfoList(this.filter),
                this.$dict.get(['action_type']),
            ]).then((args) => {
                const [res, group] = args
                Object.assign(this.dict, group)
                this.setPageData(res.data)
            }).finally(() => {
                this.loading = false
            })
        },

        search() {
            this.filter.pageNo = 1
            this.fetch()
        },

        setPageData(data) {
            data.page.list.forEach((v) => {
                v.createTime = ymdL(v.createTime)
            })
            this.page.list = data.page.list
            this.page.total = parseInt(data.page.totalCount)
        },

        // 新增
        onClickAdd(e) {
            this.actionType = '1'
            this.curId = ''
            this.modal.showInfoForm = true
        },

        // 详情
        rowClickView(row) {
            this.actionType = '2'
            this.curId = row.id
            this.modal.showInfoForm = true
        },

        // 修改
        rowClickUpdate(row) {
            this.actionType = '3'
            this.curId = row.id
            this.modal.showInfoForm = true
        },

        // 删除
        rowClickDelete(row) {
            shopInfoDelete(row.id).then(() => {
                this.$Message.success(this.$t('tips.delete.success'))
                this.fetch()
            })
        }
    },
}
</script>
<style lang="less" scoped></style>
